import React, { lazy } from 'react'
import { ReactComponent as IconContact } from '../assets/img/menu/contact.svg'
import { ReactComponent as IconDashboard } from '../assets/img/menu/dashboard.svg'
import { ReactComponent as IconInbox } from '../assets/img/menu/inbox.svg'
import { ReactComponent as IconOutbox } from '../assets/img/menu/outbox.svg'
import { ReactComponent as IconProfile } from '../assets/img/menu/profile.svg'
import { ReactComponent as IconSent } from '../assets/img/menu/sent.svg'
import { ReactComponent as IconStar } from '../assets/img/menu/starred.svg'
import { ReactComponent as IconTrash } from '../assets/img/menu/trash.svg'
import { ReactComponent as IconRefer } from '../assets/img/account/refer.svg'

import teamRoutes from './teamRoutes'

const routes = [
  {
    name: 'NewFax',
    title: 'Send Fax',
    path: '/page/newfax',
    icon: null,
    hideTab: true,
    component: lazy(() => import(/* webpackChunkName: 'newfax' */ '../page/newfax')),
  },

  {
    name: 'Dashboard',
    path: '/dashboard',
    icon: <IconDashboard />,
    component: lazy(() => import(/* webpackChunkName: 'dashboard' */ '../page/index')),
  },
  {
    name: 'Inbox',
    path: '/page/inbox',
    icon: <IconInbox />,
    component: lazy(() => import(/* webpackChunkName: 'inbox' */ '../page/inbox')),
  },
  {
    name: 'Outbox',
    path: '/page/outbox',
    icon: <IconOutbox />,
    component: lazy(() => import(/* webpackChunkName: 'outbox' */ '../page/outbox')),
  },
  {
    name: 'Star',
    title: 'Starred',
    path: '/page/star',
    icon: <IconStar />,
    component: lazy(() => import(/* webpackChunkName: 'star' */ '../page/star')),
  },
  {
    name: 'Sent',
    path: '/page/sent',
    icon: <IconSent />,
    component: lazy(() => import(/* webpackChunkName: 'sent' */ '../page/sent')),
  },
  {
    name: 'Trash',
    path: '/page/trash',
    icon: <IconTrash />,
    component: lazy(() => import(/* webpackChunkName: 'trash' */ '../page/trash')),
  },
  {
    name: 'Label',
    path: '/page/label/:id',
    icon: <IconProfile />,
    hideTab: true,
    component: lazy(() => import(/* webpackChunkName: 'label' */ '../page/label')),
  },
  //需要权限的路由
  ...teamRoutes,
  {
    divider: true,
    name: 'Contact',
    title: 'Contacts',
    path: '/page/contact',
    icon: <IconContact />,
    notExact: true,
    component: lazy(() => import(/* webpackChunkName: 'contact' */ '../page/contact')),
  },
  {
    name: 'Profile',
    path: '/page/profile',
    icon: <IconProfile />,
    notExact: true,
    component: lazy(() => import(/* webpackChunkName: 'profile' */ '../page/profile')),
  },
  {
    name: 'Refer a friend',
    path: '/page/refer',
    icon: <IconRefer />,
    component: lazy(() => import(/* webpackChunkName: 'refer' */ '../page/refer')),
  },
  // {
  //   name: 'BlackList',
  //   path: '/page/blacklsit',
  //   icon: <IconProfile />,
  //   hideTab: true,
  //   component: lazy(() => import(/* webpackChunkName: 'blacklist' */ '../page/blacklist')),
  // },
  // 跳转升级过渡页
  {
    name: 'upgrade',
    path: '/page/upgrade/:id',
    icon: <IconProfile />,
    hideTab: true,
    component: lazy(() => import(/* webpackChunkName: 'upgrade' */ '../page/upgrade')),
  },
]

export default routes
